// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    padding: 20px;
    font-family: 'Arial', sans-serif;
    max-width: 900px;
    margin: 0 auto;
}

.title {
    text-align: center;
    font-size: 2rem;
    color: #333;
}

.form {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 10px;
}

.label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.input,
.select {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid #ccc;
}

.button-container {
    display: flex;
    gap: 10px;
    margin-top: 20px;
}

.button {
    padding: 10px 20px;
    font-size: 1rem;
    border-radius: 5px;
    border: none;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
}

.button:disabled {
    background-color: #a8d3ff;
    cursor: not-allowed;
}

.message {
    color: #007bff;
    font-weight: bold;
    margin-top: 10px;
}

.sub-title {
    font-size: 1.5rem;
    color: #333;
    margin-top: 20px;
}

.table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.table th,
.table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
}

.table th {
    background-color: #f5f5f5;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AddTag.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB","sourcesContent":[".container {\n    padding: 20px;\n    font-family: 'Arial', sans-serif;\n    max-width: 900px;\n    margin: 0 auto;\n}\n\n.title {\n    text-align: center;\n    font-size: 2rem;\n    color: #333;\n}\n\n.form {\n    margin-bottom: 20px;\n}\n\n.form-group {\n    margin-bottom: 10px;\n}\n\n.label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n}\n\n.input,\n.select {\n    width: 100%;\n    padding: 10px;\n    font-size: 1rem;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n}\n\n.button-container {\n    display: flex;\n    gap: 10px;\n    margin-top: 20px;\n}\n\n.button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    border-radius: 5px;\n    border: none;\n    background-color: #007bff;\n    color: #fff;\n    cursor: pointer;\n}\n\n.button:disabled {\n    background-color: #a8d3ff;\n    cursor: not-allowed;\n}\n\n.message {\n    color: #007bff;\n    font-weight: bold;\n    margin-top: 10px;\n}\n\n.sub-title {\n    font-size: 1.5rem;\n    color: #333;\n    margin-top: 20px;\n}\n\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n}\n\n.table th,\n.table td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: left;\n}\n\n.table th {\n    background-color: #f5f5f5;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
